// extracted by mini-css-extract-plugin
export default {"button_confirm":"PopupConfirmation_button_confirm__ZunYX","title":"PopupConfirmation_title__EWBNE","subtitle":"PopupConfirmation_subtitle__EDvre"};